"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _lodash = require("lodash");
var _mobx = require("mobx");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
var RouteStore = (_class = /*#__PURE__*/function () {
  function RouteStore() {
    (0, _classCallCheck2["default"])(this, RouteStore);
    (0, _initializerDefineProperty2["default"])(this, "routerIsSetup", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "routeName", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "params", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "location", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "routes", _descriptor5, this);
  }
  return (0, _createClass2["default"])(RouteStore, [{
    key: "setRouter",
    value: function setRouter(router) {
      this.router = router;
      this.location = router && router.location;
      this.routes = router && router.routes || [];
      this.params = router && router.params;
      this.routerIsSetup = true;
    }
  }, {
    key: "setPathFor",
    value: function setPathFor(pathFor) {
      this.pathFor = pathFor;
    }
  }, {
    key: "setRouteContext",
    value: function setRouteContext(_ref) {
      var location = _ref.location,
        routes = _ref.routes,
        params = _ref.params,
        push = _ref.push,
        replace = _ref.replace,
        createHref = _ref.createHref;
      this.location = location;
      this.routes = routes || [];
      this.params = params;
      this.navigator = {
        push: push,
        replace: replace,
        createHref: createHref
      };
      this.router = {
        location: this.location,
        routes: this.routes,
        params: this.params,
        push: push,
        replace: replace,
        createHref: createHref
      };
      this.routerIsSetup = true;
    }
  }, {
    key: "setRouteName",
    value: function setRouteName(routeName, callback) {
      this.routeName = routeName;
      if ((0, _lodash.isFunction)(callback)) {
        callback();
      }
    }
  }, {
    key: "pathname",
    value: function pathname() {
      return this.location ? this.location.pathname : null;
    }
  }, {
    key: "childRoute",
    value: function childRoute() {
      return (0, _lodash.last)(this.routes);
    }
  }, {
    key: "routeTo",
    value: function routeTo(path) {
      if (this.navigator && this.navigator.push) {
        this.navigator.push(path);
      } else if (this.router) {
        this.router.push(path);
      }
    }
  }, {
    key: "routeToNamed",
    value: function routeToNamed(name, params, callback) {
      this.routeTo(this.pathFor ? this.pathFor({
        name: name,
        params: params
      }) : {
        name: name,
        params: params
      });
      this.setRouteName(name, callback);
      this.params = params;
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(url) {
      window.history.pushState({}, null, url);
    }
  }, {
    key: "queryParam",
    value: function queryParam(name) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "routerIsSetup", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "routeName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "params", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "location", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "routes", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _class);
var _default = exports["default"] = new RouteStore();